// AC1: shown to a Car Wash Minder support login while it has an account open.
import React from 'react';
import { useAuth } from '../context/AuthContext';

export default function SupportModeBanner() {
  const { selectedSupportOrg, supportAccess, switchSupportOrg } = useAuth();
  if (!selectedSupportOrg || !supportAccess) return null;
  const change = () => {
    switchSupportOrg();
    window.location.assign('/support-org-picker');
  };
  return (
    <div role="status" style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'center', gap: '10px',
      padding: '6px 16px', backgroundColor: '#1e3a8a', color: '#fff', fontSize: '13px' }}>
      <span>
        Car Wash Minder support in <strong>{selectedSupportOrg.orgName}</strong> - {supportAccess.label}
        {supportAccess.canChange ? ' (can fix settings' : ' (view only'}, last {supportAccess.historyDays} days of usage and wash data)
      </span>
      <button type="button" onClick={change}
        style={{ padding: '3px 10px', borderRadius: '4px', border: '1px solid #93c5fd', backgroundColor: 'transparent',
          color: '#fff', cursor: 'pointer', fontSize: '12px' }}>
        Switch account
      </button>
    </div>
  );
}
